import { render, staticRenderFns } from "./suketPindahDomisili.vue?vue&type=template&id=1d626ece&"
import script from "./suketPindahDomisili.vue?vue&type=script&lang=js&"
export * from "./suketPindahDomisili.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports